<template>
  <div :class="$style.wrapper">
    <button
      :class="$style.share"
      @click="handleShare"
      alt="Поделиться"
      v-tooltip="{content: 'Поделиться ВКонтакте'}"
    ></button>
    <div :class="$style.inner">
      <div :class="$style.title">
        Мои баллы за «Урок цифры» по теме «Большие данные»
      </div>
      <div :class="$style.big">
        {{total}}
      </div>
      <div :class="$style.title">
        Моя коллекция ачивок
      </div>
      <div :class="$style.list">
        <Achievement
          v-for="item in results"
          :key="item.id"
          :image="item.achievement.getImage && item.achievement.getImage(item.score / item.maxPoints)"
          :locked="false"
          :active="true"
          alt="Пройти заново"
          @click="() => goTo(item.id)"
        />
        <Achievement
          v-for="item in anotherItems"
          :key="item.id"
          :locked="true"
          :active="true"
          :image="item.achievement.grey"
          alt="Пройти это задание"
          @click="() => goTo(item.id)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import plural from '@/utils/plural'

import Achievement from '@/components/Achievement/Achievement.vue'

import { ALL_LESSONS } from '@/services/UserStory'

export default {
  name: 'Hero',
  components: { Achievement },
  computed: {
    total() {
      const { totalScore } = this.$store.getters
      return `${totalScore} ${plural(totalScore, 'балл', 'балла', 'баллов')}`
    },
    results() {
      return this.$store.state.results
    },
    anotherItems() {
      return ALL_LESSONS.filter(i => !this.results.find(i2 => i2.id === i.id))
    },
  },
  methods: {
    goTo(id) {
      this.$userStory
        .setOverflowRoutes(id)
        .moveRouter()
    },
    handleShare() {
      const text = 'Учусь анализировать данные на "Уроке цифры" по теме "Большие данные". А что интересного сможешь узнать ты? #урокцифры #mailrugroup'
      this.$vk.share({
        text, imgID: 998, bigText: this.total,
      })
    },
  },
}
</script>
<style lang="scss" module>
@import './Hero.scss';
</style>
